import { AccountCircle } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import {
    alpha,
    AppBar,
    Avatar,
    Box,
    IconButton,
    InputBase,
    Menu,
    MenuItem,
    styled,
    Toolbar,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectMainState } from "../../../stateManagement/redux";
import { logout } from "../../../stateManagement/redux/slices/shared/asyncReducers";
import "./styles.scss";

const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: "50px",
    backgroundColor: alpha("#F4F0F0", 1),
    "&:hover": {
        backgroundColor: alpha("#F4F0F0", 1),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
        width: "55%",
    },
    [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(3),
        width: "55%",
    },
    [theme.breakpoints.up("lg")]: {
        marginLeft: theme.spacing(3),
        width: "65%",
    },
    [theme.breakpoints.up("xl")]: {
        marginLeft: theme.spacing(3),
        width: "75%",
    },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "100%",
        },
    },
}));

export const Header = (props: { children?: React.ReactNode }) => {
    const dispatch = useDispatch();
    const mainState = useSelector(selectMainState);

    //Nuevo app bar

    const onLogOut = () => {
        dispatch(logout());
    };

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
        useState<null | HTMLElement>(null);

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    // const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    //     setMobileMoreAnchorEl(event.currentTarget);
    // };

    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={onLogOut}>Cerrar Sesión</MenuItem>
            {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
        </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );

    // if (width > 500) {
    return (
        <>
            <AppBar
                position="static"
                color="inherit"
                sx={{
                    borderBottom: "1px solid #129ED3",
                    height: "65px",
                }}
            >
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{
                            mr: 2,
                            display: {
                                sm: "none",
                                md: "none",
                                lg: "none",
                                xl: "none",
                            },
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ display: { xs: "none", sm: "block" } }}
                    >
                        <Box
                            component="img"
                            src="/assets/icons/logo_without_text.svg"
                            alt="logo"
                            sx={{
                                width: { xs: 40, lg: "35px", xl: "35px" },
                            }}
                        />
                        <Box
                            component="img"
                            src="/assets/icons/logo_text.svg"
                            alt="logo"
                            sx={{
                                ml: 2,
                            }}
                        />
                    </Typography>
                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                        />
                    </Search>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                        <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                            sx={{
                                display: "flex",
                            }}
                        >
                            <Avatar
                                // alt="Remy Sharp"
                                src="/static/images/avatar/1.jpg"
                                sx={{ bgcolor: "#316ebc" }}
                            />

                            <Box
                                sx={{
                                    display: {
                                        xs: "none",
                                        md: "flex",
                                    },
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    ml: 2,
                                }}
                            >
                                <Typography
                                    variant="body1"
                                    color="initial"
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: "bold",
                                    }}
                                >
                                    {mainState?.activeUser?.name}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="initial"
                                    sx={{ fontSize: 12 }}
                                >
                                    {mainState?.activeUser?.email}
                                </Typography>
                            </Box>
                        </IconButton>
                    </Box>
                    {/* <Box sx={{ display: { xs: "flex", md: "none" } }}>
                            <IconButton
                                size="large"
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={handleMobileMenuOpen}
                                color="inherit"
                            >
                                <MoreIcon />
                            </IconButton>
                        </Box> */}
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {renderMenu}
        </>
    );
};
